export const isEligibleForDeferredPayments = () => {
  try {
    const authUser = sessionStorage.getItem('isEligibleForDeferredPayments')
    return authUser === 'true'
  } catch (err) {}
  return false
}
